import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
const AddModalAdmin = ({ setShowModal, title, buttonName, setRecheck, reCheck, data , setSettingModal,setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();


    const [allValues, setAllValues] = useState({
        NationalCode: data ? data.nationalCode : '',
        Name: data ? data.name : '',
        Family: data ? data.family : '',
        PhoneNumber: data ? data.phoneNumber : '',
        UserName: data ? data.userName : '',

        Password: data ? data.password : ''

    });
    const [allValuesError, setAllValuesError] = useState({
        NationalCode: false,
        Name: false,
        Family: false,
        PhoneNumber: false,
        UserName: false,
        Password: false

    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };


    const addAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)


        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }

        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Admins/CreateAdmin", "post", {
                NationalCode: allValues?.NationalCode,
                Name: allValues?.Name,
                Family: allValues?.Family,
                PhoneNumber: allValues?.PhoneNumber,
                UserName: allValues?.UserName,
                Password: allValues?.Password,
                Email: "hsh@s.com",

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                setShowModal(false)
                setData(dataUser?.data)
                setSettingModal(true)
                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");

            }
            else {
                console.log(allValuesError)
                setEroor(dataUser?.data)

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const editAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

        setSnipper(true)


        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }
        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Admins/updateadmin", "put", {
                AdminId: data?.adminId,
                NationalCode: allValues?.NationalCode,
                Name: allValues?.Name,
                Family: allValues?.Family,
                PhoneNumber: allValues?.PhoneNumber,
                UserName: allValues?.UserName,
                Password: allValues?.Password,
                Email: "hsh@s.com",

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setEroor(dataUser.data);

                setShowErrorModalStep1(true);
            }
        }
        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[30%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="Name"
                                    placeholder="نام را اینجا بنویسید"
                                    value={allValues?.Name}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                       {
                                    allValuesError.Name ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Family"
                                    onChange={changeHandler}
                                    value={allValues?.Family}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    maxLength={100} />
                                     {
                                    allValuesError.Family ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">کد ملی</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="کد ملی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="NationalCode"
                                    onChange={changeHandler}
                                    value={allValues?.NationalCode}
                                    onInput={maxLengthCheck}
                                    maxLength={10}
                                    onKeyPress={(event) => {

                                        if (/[ا-ی]/.test(event.key)) {
                                            event.preventDefault();
                                        }

                                   
                                        if (/[a-z]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[A-Z]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                 {
                                    allValuesError.NationalCode ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا کدملی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">شماره همراه</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="شماره همراه را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    onChange={changeHandler}
                                    name="PhoneNumber"
                                    value={allValues?.PhoneNumber}
                                    onInput={maxLengthCheck}
                                    maxLength={11}
                                    onKeyPress={(event) => {

                                        if (/[ا-ی]/.test(event.key)) {
                                            event.preventDefault();
                                        }

                                       
                                        if (/[a-z]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[A-Z]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {
                                    allValuesError.PhoneNumber ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا شماره همراه را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام کاربری</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام کاربری را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="UserName"
                                    onChange={changeHandler}
                                    value={allValues?.UserName}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.UserName ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام کاربری را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">رمز عبور</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="password" placeholder="رمز عبور را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Password"
                                    onChange={changeHandler}
                                    value={allValues?.Password}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.Password ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            رمز عبور هشت رقم و دارای حرف بزرگ و کوچک ، عدد و یکی از(.@?!*) می باشد!</span>
                                        :
                                        null
                                }
                            </div>


                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalAdmin;